export interface IActionCenterSettings {
    notifications: {
        hide: boolean,
        hideEmptyItems: boolean
    },
    todo: {
        hide: boolean,
        hideEmptyItems: boolean
    },
    other: {
        hide: boolean,
        hideEmptyItems: boolean
    },
    compliance: {
        hide: boolean,
        hideEmptyItems: boolean
    }
}